import axios from 'axios';

const DEFAULT_BASE_URL = 'https://www.typortal.com/api';

const normaliseBaseUrl = (value) => {
  if (!value) {
    return DEFAULT_BASE_URL;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return DEFAULT_BASE_URL;
  }

  return trimmed.replace(/\/+$/, '');
};

const API_BASE_URL = normaliseBaseUrl(process.env.REACT_APP_API_BASE_URL);

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/`,
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  if (typeof config.url === 'string' && config.url.startsWith('/')) {
    config.url = config.url.slice(1);
  }
  return config;
});

export const buildApiUrl = (path = '') => {
  const safePath = `${path}`.replace(/^\/+/, '');
  return safePath ? `${API_BASE_URL}/${safePath}` : API_BASE_URL;
};

export { API_BASE_URL };
export default apiClient;
